module.exports = __webpack_public_path__ + "img/service-provider.79c51365.png";